import React from 'react';
import { FaMedium, FaLinkedin, FaGithub } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Button from '../../Button';
import './Footer.css';

const Footer = () => {
 
  
  
  // 🔹 State hooks for email + message
//  const [email, setEmail] = useState('');
//  const [message, setMessage] = useState('');

  // 🔹 Handle input change
//  const handleChange = (e) => {
//    setEmail(e.target.value);
//  };

  // 🔹 Handle form submit
//  const handleSubmit = async (e) => {
 //   e.preventDefault();

 /*   if (email) {
      try {
        const serverUrl = process.env.REACT_APP_API_URL;
        const response = await axios.post(serverUrl, { email });
        setMessage(response.data.message);
        setEmail('');
      } catch (error) {
        console.error('Error adding subscription:', error);
        setMessage('Please try later.');
      }
    } else {
      setMessage('Please enter a valid email.');
    }
  }; */

  // 🔹 Main component return
  return (
    <div className='footer-container text-white'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Subscribe to the Shenzu Spending Community to stay up to date on the latest financial news and trends.
        </p>

        {/* 🔹 Subscription form directly inside Footer */}
        <div className='input-areas'>
           <a href="https://getwaitlist.com/waitlist/20101" target="_blank" rel="noopener noreferrer">
            <Button buttonStyle='btn--outline'>Subscribe</Button>
           </a>
        </div>
      </section>

      <div className='footer-links text-white'>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>About Us</h2>
            <Link to='/privacy'>Privacy Policy</Link>
            <Link to='/'>Careers</Link>
            <Link to='/refundpolicy'>
              Refund and Cancellation Policy
            </Link>
            <Link to='/terms'>Terms and Conditions</Link>
          </div>

          <div className='footer-link-items'>
            <h2>Videos</h2>
            <Link to='/'>Fintech</Link>
            <Link to='/'>Analytics</Link>
            <Link to='/'>Risk Management</Link>
          </div>
        </div>

        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>Contact Us</h2>
            <Link to='/contact'>Contact</Link>
            <Link to='/'>Sponsorships</Link>
            <Link to='/'>Support</Link>
          </div>

          <div className='footer-link-items'>
            <h2>Social Media</h2>
            <Link to='//github.com/' target='_blank' aria-label='Github'>
              Github
            </Link>
            <a href='https://www.linkedin.com/company/shenzu-spending' target='_blank' rel='noopener noreferrer' aria-label='LinkedIn'>
              LinkedIn
            </a>
            <Link to='//medium.com/' target='_blank' aria-label='Medium'>
              Medium
            </Link>
          </div>
        </div>
      </div>

      <section className='social-media'>
        <div className='social-media-wrap'>
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
              SHENZU SPENDING
            </Link>
          </div>
          <small className='website-rights'>SHENZU SPENDING © 2026</small>
          <div className='social-icons'>
            <Link className='social-icon-link' to='//github.com/' target='_blank' aria-label='Github'>
              <FaGithub />
            </Link>
            <a
              className='social-icon-link'
              href='https://linkedin.com/company/shenzu-spending/'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='LinkedIn'
            >
              <FaLinkedin />
            </a>
            <Link className='social-icon-link' to='//medium.com/' target='_blank' aria-label='Medium'>
              <FaMedium />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
